<template>
  <div v-if="homeworks.length > 0">
    <div class="recent-homework-section">
      <!-- TITLE -->
      <div class="page-title font-weight-bold color_text">Recent Homework</div>

      <!-- HOMEWORK CARD COMPONENT -->
      <HomeworkCard
        :id="homework.id"
        :date="homework.created_at"
        :title="homework.title"
        :subject="homework.subject.name"
        :class_id="homework.class_id"
        :status="homework.expiry_status"
        :progress_bar="homework.completion.toString()"
        v-for="(homework, index) in homework_list"
        :key="index"
      ></HomeworkCard>
      <!-- HOMEWORK CARD COMPONENT -->

      <div class="show-more" v-if="show_more">
        <div @click="showMoreHomwork" class="btn-link font-weight-bold">
          See {{ text_addon }}
          <span class="text-capitalize">{{ getFirstname }}</span
          >’s Homework
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Homework",

  props: {
    teacher_name: String,
    homeworks: Array,
  },

  components: {
    HomeworkCard: () =>
      import(
        /* webpackChunkName: "homework" */ "@/components/classComps/homework/HomeworkCard"
      ),
  },

  computed: {
    getFirstname() {
      return this.teacher_name.split(" ")[0];
    },
  },

  watch: {
    homeworks: {
      handler(newVal) {
        if (newVal) this.loadHomework();
      },
      immediate: true,
    },
  },

  data() {
    return {
      base_homework_list: [],
      homework_list: [],
      shrinked: true,
      text_addon: "",
      show_more: false,
    };
  },

  methods: {
    loadHomework() {
      this.base_homework_list = this.homeworks;
      this.homework_list = this.homeworks;
      if (this.homework_list.length > 4) {
        this.show_more = true;
        this.text_addon = "More";
        this.homework_list = this.homework_list.slice(0, 4);
      } else this.show_more = false;
    },

    showMoreHomwork() {
      this.shrinked = !this.shrinked;
      if (this.shrinked) {
        if (this.homework_list.length > 4)
          this.homework_list = this.homework_list.slice(0, 4);
        this.text_addon = "More";
      } else {
        this.homework_list = this.base_homework_list;
        this.text_addon = "Less";
      }
    },
  },
};
</script>

<style lang="scss">
.recent-homework-section {
  margin-bottom: 70px;
}
</style>
